import type { DateRange, OrgUsage } from "@/types/api";
import { http } from "./http";

/**
 * Per-named-member ACTIVITY.
 *
 * The Gateway enforces the activity/content boundary in its own analytics
 * layer: time, topics, completions and streaks are exposed; questions, notes
 * and the learner's inferred profile are not. Nothing on this side should
 * present the data as though it were more than that.
 *
 * Each read is audited server-side as `member.viewed`, so an employee asking
 * who looked at their activity has an answer.
 */
export const usageService = {
	get: (range: DateRange = {}, signal?: AbortSignal) =>
		http.get<OrgUsage>("/api/org/usage", {
			query: { from: range.from, to: range.to },
			signal,
		}),
};
